import type { AmplitudeProductEventName } from './productEvents';
import { AmplitudeProductEvent } from './productEvents';

/**
 * Product payload key → pre-taxonomy key, per event. Scoped per event because the same
 * snake_case key was already live on other events (e.g. `resource_id` on `resource_not_found`).
 */
const LEGACY_PROPERTY_KEY_BY_PRODUCT: Partial<
  Record<AmplitudeProductEventName, Readonly<Record<string, string>>>
> = {
  [AmplitudeProductEvent.RESOURCE_VIEW]: {
    resource_id: 'resourceId',
    resource_name: 'resourceName',
    content_type: 'contentType',
  },
  [AmplitudeProductEvent.SEARCH_RESULT]: {
    smart_search_enabled: 'smartSearchEnabled',
    smart_search_intent: 'smartSearchIntent',
  },
  [AmplitudeProductEvent.SEARCH_RESULT_CLICK]: {
    smart_search_enabled: 'smartSearchEnabled',
  },
  [AmplitudeProductEvent.CONTENT_ISSUE]: {
    document_id: 'documentId',
  },
};

/** Rewrites bucket **(b)** product payload keys to pre-taxonomy names (flag off). */
export const toLegacyEventProperties = (
  productEvent: AmplitudeProductEventName,
  properties: Record<string, unknown>,
): Record<string, unknown> => {
  const keyMap = LEGACY_PROPERTY_KEY_BY_PRODUCT[productEvent];
  if (!keyMap) {
    return properties;
  }
  const legacy: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(properties)) {
    legacy[keyMap[key] ?? key] = value;
  }
  return legacy;
};
